import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  params: { page: 1, sort_by: "nome", sort_direction: "ASC" },
  filters: { limit: 20 },
};

export const ProdutcsSlice = createSlice({
  name: "taxAnalysisProductsFilter",
  initialState,
  reducers: {
    handleAddFilter: (state, { payload }) => {
      state.filters = payload;
      state.params.page = 1;
    },
    handleCleanFilter: (state, { payload }) => {
      delete state.filters.nome;
      delete state.filters.issue_date_start;
      delete state.filters.issue_date_end;
      state.filters.limit = payload.limit;
    },
    handleParams: (state, { payload }) => {
      state.params[payload.field] = payload.value;
    },
  },
});

export const { handleAddFilter, handleCleanFilter, handleParams } =
  ProdutcsSlice.actions;
export default ProdutcsSlice.reducer;
